import { z } from "zod";

// Stable UUID for the "Valerie Automation" user row inserted in
// 20260519175400_insert_valerie_automation_user.sql. Used as the user_id for
// rows created by Valerie itself (voice/SMS ingestion, future automations)
// rather than a teammate.
export const VALERIE_AUTOMATION_USER_ID = "0c89cdd7-1bcf-4748-a2ba-19b5a5d4ff59";

export const userSchema = z.object({
  givenName: z.string(),
  familyName: z.string(),
  email: z.string(),
  createdAt: z.string(),
  updatedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
  id: z.string(),
});

export enum RBACRole {
  INTERNAL_ADMIN = "internal_admin",
  INTERNAL_DEFAULT = "internal_default",
  INTERNAL_LIMITED = "internal_limited",
  EXTERNAL_ANALYTICS = "external_analytics",
  // External customer admins: same read access as external_analytics, plus the ability to manage
  // their organization's members (add users) via the Permissions Management tool.
  EXTERNAL_ADMIN = "external_admin",
  // External scheduling users: inbox read/write access so they can view and respond to patient
  // scheduling conversations.
  EXTERNAL_SCHEDULING = "external_scheduling",
  // External analytics read-only: analytics read + SOR read; no inbox or tasks.
  EXTERNAL_ANALYTICS_READONLY = "external_analytics_readonly",
  // External orders users: read-only access to the patient orders surface.
  EXTERNAL_ORDERS = "external_orders",
}

export type User = z.infer<typeof userSchema>;

export const userShape: User = {
  id: "",
  givenName: "",
  familyName: "",
  email: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
};

export function getUserFullName(user: User): string {
  return [user.givenName, user.familyName].filter(Boolean).join(" ");
}
